import { Link, useParams } from 'react-router-dom';
import { DirectMemberComparisonItemPropsType } from '../../types';
import { useTranslation } from 'react-i18next';
import { useMunicipalityId } from '../../hooks/useCouncilPath';
import { buildCouncilPath } from '../../utils/councilParams';

// Utility function to allow nested valueKeys for example 'dochazka.mandat'
const getNestedValue = (obj: any, path: string) => {
    return path.split('.').reduce((acc, key) => acc && acc[key], obj);
};

const DirectMemberComparisonItem = ({
    firstMemberData,
    secondMemberData,
    valueKey,
    formattingFunc,
    description,
    isLinkToMember
}: DirectMemberComparisonItemPropsType) => {
    const { bodyType, zastupitelstvoId } = useParams();
    const municipalitaId = useMunicipalityId();

    const firstMemberValue = getNestedValue(firstMemberData, valueKey);
    const secondMemberValue = getNestedValue(secondMemberData, valueKey);
    const { t, i18n } = useTranslation();

    return (
        <div className='members-comparison-summary-item'>
            <h4>
                {isLinkToMember ? (
                    <>
                        <Link
                            to={buildCouncilPath(municipalitaId, bodyType, zastupitelstvoId, 'zastupitele', firstMemberData?.id ?? '')}
                        >
                            {formattingFunc && firstMemberValue !== null
                                ? formattingFunc(firstMemberValue, firstMemberData, t, i18n, {
                                      municipalitaId,
                                      bodyType,
                                      zastupitelstvoId
                                  })
                                : firstMemberValue?.toString()}
                        </Link>
                    </>
                ) : formattingFunc && firstMemberValue !== null ? (
                    formattingFunc(firstMemberValue, firstMemberData, t, i18n, {
                        municipalitaId,
                        bodyType,
                        zastupitelstvoId
                    })
                ) : (
                    firstMemberValue?.toString()
                )}
            </h4>
            <p className='members-comparison-summary-item-description'>{description}</p>
            <h4>
                {isLinkToMember !== undefined ? (
                    <Link to={buildCouncilPath(municipalitaId, bodyType, zastupitelstvoId, 'zastupitele', secondMemberData?.id ?? '')}>
                        {formattingFunc && secondMemberValue !== null
                            ? formattingFunc(
                                  secondMemberValue,
                                  secondMemberData,
                                  t,
                                  i18n,

                                  {
                                      municipalitaId,
                                      bodyType,
                                      zastupitelstvoId
                                  }
                              )
                            : secondMemberValue?.toString()}
                    </Link>
                ) : formattingFunc && secondMemberValue !== null ? (
                    formattingFunc(secondMemberValue, secondMemberData, t, i18n, {
                        municipalitaId,
                        bodyType,
                        zastupitelstvoId
                    })
                ) : (
                    secondMemberValue?.toString()
                )}
            </h4>
        </div>
    );
};

export default DirectMemberComparisonItem;
